export default __webpack_public_path__ + "003dd33d18c7cf35dbbc06bf1db96832.png";